// แปลง error จาก GS/ระบบ เป็นข้อมูลให้ UI แสดงชัดเจน (code ตาม docs/API.md)
const NO_CHARGE = ["ai_busy", "ai_blocked", "ai_error", "ai_cancelled", "ai_not_ready", "ai_unsupported"];

/** "ต้องการ 10 คอยน์ แต่มี 3 คอยน์" -> { need: 10, have: 3 } */
const parseCoins = (msg) => {
  const m = String(msg || "").match(/ต้องการ\s*([\d,]+).*?มี\s*([\d,]+)/);
  return m ? { need: Number(m[1].replace(/,/g, "")), have: Number(m[2].replace(/,/g, "")) } : {};
};

export const errorInfo = (e) => {
  const code = e?.code || "";
  const raw = e?.message || "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง";
  const info = { code, message: raw, needCredits: code === "insufficient_credits", needCoins: false, noCharge: false, retryable: false };
  if (code === "insufficient_coins") return { ...info, needCoins: true, ...parseCoins(raw) };
  if (NO_CHARGE.includes(code)) {
    const WHY = {
      ai_blocked: "AI ไม่สามารถตอบข้อความนี้ได้ ลองเปลี่ยนคำหรือเนื้อหา",
      ai_error: "AI ในเครื่องขัดข้อง ลองใหม่อีกครั้ง",
      ai_cancelled: "ยกเลิกการสร้างคำตอบแล้ว",
      ai_not_ready: "ยังไม่ได้โหลดโมเดล AI — กด \"โหลดโมเดล\" ด้านบนห้องแชทก่อน",
      ai_unsupported: raw,
    };
    const why = WHY[code] || "ระบบ AI ไม่ว่างในขณะนี้";
    return { ...info, message: code === "ai_unsupported" ? why : `${why} — ไม่ได้หักคอยน์`, noCharge: true, retryable: code === "ai_busy" || code === "ai_error" };
  }
  if (code === "chat_busy") return { ...info, message: "ตัวละครกำลังตอบข้อความก่อนหน้าอยู่ รอสักครู่แล้วลองใหม่", retryable: true };
  if (code === "rate_limited") return { ...info, message: "ส่งถี่เกินไป รอสักครู่แล้วลองใหม่", retryable: true };
  if (code === "payment_pending") return { ...info, retryable: true };
  return info;
};
